module.exports = __webpack_public_path__ + "static/media/WHAlogonew.cdc8fcd3.png";